import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'tech-core-quiz-admin',
  standalone: false,
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss'
})
export class AdminComponent implements OnInit {

  loginUrl = '/api/admin/login/start?redirect='
  adminPage = "/configuration"

  ngOnInit() {
  }

  start() {
    location.href = this.loginUrl + location.origin + this.adminPage
  }

}
